// extracted by mini-css-extract-plugin
export default {"image":"oY-z","loaded":"pY-z"};